import { Injectable } from '@angular/core';
import { IAbstractPresenter } from '@core/interfaces';
import { INoteComponent, INotePresenter } from './interfaces';

@Injectable()
export class NotePresenter 
  extends IAbstractPresenter<INoteComponent>
  implements INotePresenter 
{
  constructor() {
    super();
  }

  dispatchActions(): void {}
  suscribeObservers(): void {}
}
